import Vue from "vue";
import VueRouter from "vue-router";
import Home from '../views/Home.vue'

const PrivacyPolicy = () => import('../views/PrivacyPolicy.vue');
const PageNotFound = () => import('../views/PageNotFound.vue');
// const VModal = () => import('../components/Modal/VModal.vue');

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    children:[
      {
        path: '/modal/:status',
      },
    ]
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: PrivacyPolicy
  },
  {
    path: "*",
    component: PageNotFound
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth"
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
